var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoutiqueWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.47368H2L4.5 4.34211H19.5L22 6.47368ZM4.57813 3H19.3437V4.02632H4.57813V3ZM20.0923 19.7431V10.0739C21.1687 9.79192 22 8.80887 22 7.63239V7.02632H2V7.64053C2 8.81692 2.79742 9.79192 3.87375 10.0739V19.7431H2V21H22V19.7431H20.0923ZM5.11773 19.7431V10.0739C6.19422 9.79192 6.99148 8.817 6.99148 7.64053C6.99148 8.81692 7.78891 9.79192 8.86523 10.0739V19.7431H5.11773ZM18.8404 19.7431H14.3673V18.0711C16.0317 18.0403 16.9866 17.7152 16.9866 17.3186C16.9866 17.2442 16.9523 17.1724 16.8868 17.1045L14.7426 13.6703C14.7054 13.6094 14.6966 13.5351 14.7188 13.467L15.0927 12.3324L15.1448 11.5387L14.6612 11.4257C14.5268 11.3943 14.4316 11.2733 14.4316 11.1339V10.8635H13.7814V11.1339C13.7814 11.2733 13.6862 11.3943 13.5517 11.4257L13.0682 11.5387L13.1202 12.3324L13.4923 13.467C13.5144 13.5351 13.5056 13.6094 13.4685 13.6703L11.3261 17.1016C11.2587 17.1703 11.2238 17.2431 11.2238 17.3186C11.2238 17.7186 12.1945 18.0457 13.8846 18.0719V19.7431H9.48734V10.1626C10.8668 10.1626 11.9831 9.0345 11.9831 7.64053C11.9831 8.52687 12.5709 10.1626 14.4789 10.1626C16.2028 10.1626 16.9667 8.47847 16.9667 7.64053C16.9667 8.81692 17.7641 9.79192 18.8405 10.0739L18.8404 19.7431Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoutiqueWhite);
export default __webpack_public_path__ + "static/media/boutique-white.1726ddd915fe94ad44ab14eea08b300c.svg";
export { ForwardRef as ReactComponent };